import 'driver.js/dist/driver.min.css';
import './index.less';

import Driver from 'driver.js';
import { useRef } from 'react';
import { useDispatch } from 'react-redux';

import { useLocale } from '../../locales';
import { setUserItem } from '../../stores/user.store';

export const useGuide = () => {
  const { formatMessage } = useLocale();
  const dispatch = useDispatch();

  const driver = useRef(
    new Driver({
      keyboardControl: false,
      allowClose: false,
      overlayClickNext: true,
      closeBtnText: formatMessage({ id: 'app.guide.driverjs.closeBtnText' }),
      prevBtnText: formatMessage({ id: 'app.guide.driverjs.prevBtnText' }),
      nextBtnText: formatMessage({ id: 'app.guide.driverjs.nextBtnText' }),
      doneBtnText: formatMessage({ id: 'app.guide.driverjs.doneBtnText' }),
    }),
  );

  const driverStart = () => {
    setTimeout(() => {
      const steps = [
        {
          element: '#sidebar-trigger',
          popover: {
            title: formatMessage({ id: 'app.guide.driverStep.sidebarTrigger.title' }),
            description: formatMessage({ id: 'app.guide.driverStep.sidebarTrigger.description' }),
            position: 'bottom',
            offset: 10,
            isFirst: true,
          },
        },
        {
          element: '#notice-center',
          popover: {
            title: formatMessage({ id: 'app.guide.driverStep.notices.title' }),
            description: formatMessage({ id: 'app.guide.driverStep.notices.description' }),
            position: 'bottom',
            offset: -160,
          },
        },
        {
          element: '#pageTabs .ant-tabs-nav',
          popover: {
            title: formatMessage({ id: 'app.guide.driverStep.pageTabs.title' }),
            description: formatMessage({ id: 'app.guide.driverStep.pageTabs.description' }),
            position: 'bottom',
            offset: 30,
          },
        },
        {
          element: '#pageTabs-actions svg',
          popover: {
            title: formatMessage({ id: 'app.guide.driverStep.pageTabsActions.title' }),
            description: formatMessage({ id: 'app.guide.driverStep.pageTabsActions.description' }),
            position: 'left',
          },
        },
        {
          element: '#switchTheme',
          popover: {
            title: formatMessage({ id: 'app.guide.driverStep.switchTheme.title' }),
            description: formatMessage({ id: 'app.guide.driverStep.switchTheme.description' }),
            position: 'left',
            isLast: true,
          },
        },
      ];

      // Only include steps whose target actually exists — a missing element
      // makes driver.js throw "There are no steps defined to iterate".
      const availableSteps = steps.filter((step) => document.querySelector(step.element));
      if (!availableSteps.length) return;
      availableSteps[0].popover.isFirst = true;
      availableSteps[availableSteps.length - 1].popover.isLast = true;

      driver.current.defineSteps(availableSteps);

      localStorage.setItem('newUser', 'false');
      dispatch(
        setUserItem({
          newUser: false,
        }),
      );
      driver.current.start();
    }, 1000);
  };

  return {
    driverStart,
  };
};

export default useGuide;
